import { render, staticRenderFns } from "./form-new-email-otp-confirm.vue?vue&type=template&id=119497a8&scoped=true&lang=pug"
import script from "./form-new-email-otp-confirm.vue?vue&type=script&lang=js"
export * from "./form-new-email-otp-confirm.vue?vue&type=script&lang=js"
import style0 from "./form-new-email-otp-confirm.vue?vue&type=style&index=0&id=119497a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119497a8",
  null
  
)

export default component.exports